module.exports = __webpack_public_path__ + "media/images/application/template/logos/placeholder-logo-wide-1b611dafe8f81b508b09c49c2d04c371.png";